import { useMutation } from '@tanstack/react-query';
import { useChatApiClient } from '@trinity/chat-components/containers/Chat';

export function useCancelSegmentChat({ queryIdentifier }: { queryIdentifier: string }) {
  const apiClient = useChatApiClient();

  return useMutation({
    mutationFn: async () => {
      const response = await apiClient.authenticatedClient.post('/chat/segment-chat/cancel', {
        queryIdentifier,
      });
      return response.data;
    },
  });
}
